module.exports = __webpack_public_path__ + "img/CU.e7b5aca2.svg";